export default __webpack_public_path__ + "static/video-desktop-a01e468c49d72166dbde284a7d99a9e0.mp4";